<template>
  <div>
    <div class="language">
      <div class="language__header" v-html="title"></div>
      <div class="language__caption" v-html="subTitle"></div>
      <div class="language__action" v-for="(item, index) in arrData" :key="index">
        <button-text
          class="btn"
          :class="objUserSetting.language == item.code ? 'btn--active' : null"
          :action="onSelectedLanguage"
          :value="item.code"
          :data-action="getDataAction(item.code)"
        >
          <template #body>
            <div>{{ item.name }}</div>
          </template>
        </button-text>
      </div>
    </div>
    <OnboardingTheme @callback-func="onSelectedTheme" :objUserSetting="objUserSetting" />
  </div>
</template>

<script>
import { ButtonText } from "../../atoms"
export default {
  components: {
    ButtonText,
    OnboardingTheme: () => import("../../molecules/Onboarding/OnboardingTheme")
  },
  props: {
    title: {
      type: String,
      default: "",
      required: false
    },
    subTitle: {
      type: String,
      default: "",
      required: false
    },
    arrData: {
      type: Array,
      default: function() {
        return [
          { name: "ภาษาไทย", code: "TH" },
          { name: "English", code: "EN" }
        ]
      }
    },
    objUserSetting: {
      type: Object,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    onSelectedLanguage(val) {
      this.$emit("callback-func", { val: val, type: "language" })
    },
    onSelectedTheme(val) {
      this.$emit("callback-func", { val: val, type: "theme" })
    },
    getDataAction(val) {
      switch (val) {
        case "TH":
          return "select_thai"
        case "EN":
          return "select_eng"
        default:
          return "select_" + val
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles/_OnboardingLanguage";
</style>